import React, { useState, useEffect } from "react";
import Header from "./include/header";
import Footer from "./include/footer";
import UserLeftPanel from "./include/LeftPanel";
import axios from "axios";
import Global from "../APIConfig";
import { ToastContainer, toast } from '../components/ui/toast';
import { useNavigate, useParams, Link } from "react-router-dom";
import MainLoader from "./Loaders/MainLoader";
import AuthUser from "../AuthUser";
import { ArrowLeft, Wallet, TrendingUp, TrendingDown } from "lucide-react";


/**
 * WalletContent — wallet balance cards + transaction history.
 * Used both by the standalone /CustomerWallet page and the /Finance hub tab.
 */
export function WalletContent() {
    let navigate = useNavigate();
    const { headers1, headers2, logout } = AuthUser();
    const [Loading, setLoading] = useState(true);
    const [TotalCr, setTotalCr] = useState('');
    const [TotalDr, setTotalDr] = useState('');
    const [WalletHistory, setWalletHistory] = useState([]);
    const [gDefaultCurrency, setGDefaultCurrency] = useState('$');

    useEffect(() => {
        getCutomerWalletDetail();
    }, []);
    const items = JSON.parse(localStorage.getItem('user'));
    const getCutomerWalletDetail = () => {
        setLoading(true);
        axios({
            method: 'post',
            url: Global.baseUrl + 'getfrontCutomerWalletDetail',
            headers: headers1,
            data: {
                UniqueId: items.uniqueid,
            }
        })
            .then(function (response) {
                if (response.data.status == 200) {
                    var data = response.data.value;
                    setTotalCr(data.totalcr);
                    setTotalDr(data.totaldr);
                    setWalletHistory(data.history);
                    setGDefaultCurrency(data.gDefaultCurrency)
                }
                setLoading(false);
            })
            .catch(function (error) {
                if (error.response.status == 401) {
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                setLoading(false);
            });
    }

    if (Loading) return <MainLoader />;

    const available = (parseFloat(TotalCr || 0) - parseFloat(TotalDr || 0)).toFixed(2);

    return (
        <>
            <div className="px-pagehead">
                <div className="px-pagehead__left">
                    <button className="px-btn px-btn--ghost px-btn--sm" onClick={() => navigate(-1)} aria-label="Go back">
                        <ArrowLeft size={16} />
                    </button>
                    <h2 className="px-pagehead__title">Wallet</h2>
                </div>
            </div>

            <p className="px-finance-help">
                Your prepaid balance with Pram Express — money added to your account (Credited)
                and what has been spent on shipments (Spent). Available is what you can use now.
            </p>

            <div className="px-stat-grid">
                <div className="px-card px-card--stat">
                    <span className="px-stat__icon"><Wallet size={22} /></span>
                    <div>
                        <div className="px-stat__value">{gDefaultCurrency}{available}</div>
                        <div className="px-stat__label">Available Balance</div>
                    </div>
                </div>
                <div className="px-card px-card--stat">
                    <span className="px-stat__icon"><TrendingUp size={22} /></span>
                    <div>
                        <div className="px-stat__value">{gDefaultCurrency}{parseFloat(TotalCr || 0).toFixed(2)}</div>
                        <div className="px-stat__label">Credited (added)</div>
                    </div>
                </div>
                <div className="px-card px-card--stat">
                    <span className="px-stat__icon"><TrendingDown size={22} /></span>
                    <div>
                        <div className="px-stat__value">{gDefaultCurrency}{parseFloat(TotalDr || 0).toFixed(2)}</div>
                        <div className="px-stat__label">Spent (debits)</div>
                    </div>
                </div>
            </div>

            <div className="px-table-wrap">
                <table className="px-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Entry Date</th>
                            <th>Transaction Id</th>
                            <th>Type</th>
                            <th>Amount</th>
                            <th>Payment Mode</th>
                            <th>Payment Detail</th>
                        </tr>
                    </thead>
                    {WalletHistory.length > 0 ?
                        <tbody>
                            {WalletHistory.map((history, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td className="text-capitalize">{history.date}</td>
                                        <td className="text-capitalize">{history.transaction_id}</td>
                                        <td>
                                            <span className="px-badge px-badge--neutral">{history.Dr > 0 ? 'Payment' : 'Top-up'}</span>
                                        </td>
                                        <td>
                                            {history.Dr > 0 ?
                                                <span className="px-amount px-amount--dr">-{gDefaultCurrency}{history.Dr}</span>
                                                :
                                                <span className="px-amount px-amount--cr">+{gDefaultCurrency}{history.Cr}</span>
                                            }
                                        </td>
                                        <td className="text-capitalize">{history.mode}</td>
                                        <td className="text-capitalize">{history.detail_type}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                        :
                        <tbody>
                            <tr><td colSpan={7} className="px-table__empty">Record Not Found</td></tr>
                        </tbody>
                    }
                </table>
            </div>
        </>
    );
}

function CustomerWallet() {
    return (
        <>
            <UserLeftPanel />
            <main className="px-main">
                <Header />
                <ToastContainer />
                <div className="px-content">
                    <WalletContent />
                </div>
                <Footer />
            </main>
        </>
    );
}
export default CustomerWallet;
